module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("企業更新")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('company-form', {
    attrs: {
      "id": _vm.companyId
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e952578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/Edit.vue
// module id = 471
// module chunks = 1